let message = "You have unsaved changes on this page. Are you sure do you want to leave without saving?";
let options = {
  okText: "Leave",
  cancelText: "Stay"
};

export default {
  data () {
    return {
      formChanged: false
    };
  },

  computed: {
    useConfirmDialog () {
      return this.$options.name.toLowerCase().includes("edit") ||
             this.$options.name.toLowerCase().includes("new") ||
             this.formPage;
    },

    usedResourceName () {
      return this.resourceName || "resource";
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.useConfirmDialog && this.formChanged) {
      this.$dialog.confirm(message, options)
        .then(function () {
          next();
        })
        .catch(function () {
          next(false);
        });
    } else {
      next();
    }
  },

  mounted: function () {
    if (this.useConfirmDialog) {
      this.$watch(this.usedResourceName, (val) => {
        this.formChanged = true;
      }, { deep: true });
    }
  }
};
